import { render, staticRenderFns } from "./ProductCards.vue?vue&type=template&id=66032962&scoped=true&"
import script from "./ProductCards.vue?vue&type=script&lang=js&"
export * from "./ProductCards.vue?vue&type=script&lang=js&"
import style0 from "./ProductCards.vue?vue&type=style&index=0&id=66032962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66032962",
  null
  
)

export default component.exports